import React from 'react';
import { Typography, Card, CardContent, Box } from '@mui/joy';
import MainLayout from '../../components/Layout/MainLayout';

const PreviewPage = () => {
  return (
    <MainLayout currentPage="preview">
      <Box>
        <Typography level="h2" sx={{ fontWeight: 600, mb: 3 }}>
          Content Preview
        </Typography>
        
        <Card variant="outlined">
          <CardContent sx={{ textAlign: 'center', py: 6 }}>
            <Box sx={{ fontSize: '4rem', mb: 2 }}>👁️</Box>
            <Typography level="title-lg" sx={{ mb: 1 }}>
              Preview Mode Coming Soon
            </Typography>
            <Typography level="body-md" sx={{ color: 'neutral.600' }}>
              Preview how content will appear on your digital displays.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </MainLayout>
  );
};

export default PreviewPage;